import { learningServiceRequest } from "./utils";

const perksServices = {
  async list(search) {
    const { data: response } = await learningServiceRequest({
      method: "get",
      url: "/perks",
      params: { limit: 10, q: search },
      failureMessage: "Error loading Perks",
    });
    return response?.data?.items ?? [];
  },
};

export default perksServices;
